<template>
  <div class="boost-view-menu" :style="{ background: backgroundColor }">
    <ui-switcher
      :text-bold="true"
      class="boost-view-switch"
      :model-value="store.reportBoostEnabled"
      :label="t('Boost View')"
      @change="setBoostMode"
    />

    <p
      class="pt-10"
      v-html="
        t(
          '<b>Boost View</b> improves panel performance when working with a large number of elements. In this mode, statistics are hidden to reduce system load, but all elements remain editable. Editing and saving operations are significantly faster.',
        )
      "
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n, usePickerPushUrl } from '@/composables';
import { useStore } from '@/store';
import { $emitter } from '@/services/emitter';
import query from '@/components/query/query-constructor';

const props = withDefaults(
  defineProps<{
    backgroundColor?: string;
    changePlanClick?: () => void;
  }>(),
  {
    backgroundColor: 'var(--color-mobile-menu-bg)',
  },
);

const store = useStore();
const route = useRoute();
const { t } = useI18n();
const { pushReportUrl } = usePickerPushUrl();

const setBoostMode = () => {
  if (route.name !== 'app.report') {
    const boostEnabled = !store.reportBoostEnabled;
    store.setReportBoostEnabled(boostEnabled);
    props.changePlanClick?.();
    return;
  }

  store.setLoading(true);
  const boostEnabled = !store.reportBoostEnabled;
  store.setReportBoostEnabled(boostEnabled);
  pushReportUrl(() => {
    $emitter.emit('refresh-report');
  });
  props.changePlanClick?.();
};

onMounted(() => {
  const routeParams = query.decode(route.params.data as string);
  if (!routeParams) return;
  const { reportBoostEnabled } = routeParams;
  const reportBoostEnabledFromRoute =
    reportBoostEnabled ||
    JSON.parse(localStorage.getItem('report-boost-enabled') || 'false');

  store.setReportBoostEnabled(reportBoostEnabledFromRoute);
});
</script>

<style lang="scss" scoped>
.boost-view-menu {
  padding: 16px;
  border-radius: inherit;
}

.boost-view-switch {
  justify-content: space-between;
}

:deep(.v-menu__activator) {
  height: 100% !important;
}
</style>
